<template>
    <form class="form" @submit="handleSubmit">
        <FormControlDynamicSector
            :label="label"
            name="sectors"
            v-model="selectedSector"
            :options="dropdownOptions"
            :default-items="defaultItems"
            :include-parent-sector="false"
            :parent-sector-id="defaultSectorId"
            v-on:input="handleSectorChange"
        />
    </form>
</template>
<script>
import FormControlDynamicSector from '@components/Form/Control/FormControlDynamicSector';

export default {
    name: 'SectorViewFilters',
    components: {
        FormControlDynamicSector
    },
    props: {
        defaultSectorId: {
            type: Number,
            required: true,
        },
        defaultItems: {
            type: Array,
            default: () => ([]),
        },
        label: {
            type: String,
            default: "Filter By..."
        }
    },
    data() {
        return {
            sectors: [],
            selectedSector: null,
        }
    },
    methods: {
        handleSubmit(ev) {
            ev.preventDefault();
        },
        handleSectorChange(value) {
            this.$emit("input", typeof value !== "undefined" ? value : this.defaultSectorId);
        }
    },
    computed: {
        dropdownOptions: function() {
            return {
                multiple: false,
                autoSelectAncestors: false,
                includeAncestors: false,
                autoLoadRootOptions: true,
                async: true,
                defaultOptions: true,
            }
        }
    },
}
</script>
<style lang="scss" scoped>
@import '~reflex-grid/scss/includes/variables';
@import '~reflex-grid/scss/includes/mixins';
@import '~@/theme/_variables.scss';
@import '~@/mixins/_class.scss';
@import '~@/theme/_extenables.scss';
</style>

